<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Add an item</h4>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v" class="form-wrapper">
                <div class="item-barcode">
                    <form-group label="Barcode">
                        <md-input v-model="barcode" />
                    </form-group>
                </div>
                <div class="item-description">
                    <form-group name="description" label="Description">
                        <md-input v-model="description" />
                    </form-group>
                </div>
                <div class="item-description">
                    <form-group name="installationTime" label="Installation Time In Minutes">
                        <md-input v-model="installationTimeInMinutes" />
                    </form-group>
                </div>
                <div v-if="loadFieldList !== null">
                    <load-inputs
                        v-for="(load, index) in loadFieldList"
                        :key="index"
                        :load-definition="load"
                        :initial-value="loadValues"
                        @changed="handleLoadChanged"
                    />
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button class="md-primary dialog-button" @click="addItemline">
                Save
            </md-button>
            <md-button class="md-default dialog-button" @click.stop="$modal.hide">
                Cancel
            </md-button>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { required } from 'vuelidate/lib/validators';
import { handleRequests, showErrorMessage } from '@/helpers';
import { mapGetters } from 'vuex';
import { LoadInputs } from '@/components';

export default {
    name: 'ItemLineModal',
    mixins: [GeneralMixin],
    components: { LoadInputs },
    props: {
        shipmentId: {
            type: Number,
            default: null
        },
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    validations: {
        barcode: {
            required
        }
    },
    data() {
        return {
            barcode: null,
            description: '',
            sku: null,
            productReference: null,
            installationTimeInMinutes: null,
            loadFieldList: [],
            loadValues: {}
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        })
    },
    mounted() {
        this.loadFieldList = [];
        if (this.user.vehicleCapacityUnitsConfiguration && this.user.vehicleCapacityUnitsConfiguration.length > 0) {
            this.loadFieldList = this.user.vehicleCapacityUnitsConfiguration.filter((x) => x.type !== 'quantity');
        }
    },
    methods: {
        async addItemline() {
            if (this.$v.$invalid) {
                showErrorMessage(this, 'Barcode is required');
                return;
            }

            this.$_handleLoaderState(true, 'UPDATING...');
            const payload = {
                method: 'post',
                data: {
                    barcode: this.barcode,
                    description: this.description,
                    installationTimeInMinutes: this.installationTimeInMinutes,
                    load: this.loadValues
                }
            };
            try {
                const api = `/api/shipments/${this.shipmentId}/lines`;
                await handleRequests(api, payload);

                this.$notify({
                    message: `Item added!`,
                    type: 'success'
                });
                this.$v.$reset();

                this.resolve(true);
            } catch (e) {
                let message = 'Cannot add item.';

                ({
                    data: [{ message }]
                } = e);

                showErrorMessage(this, message);
                this.resolve(false);
            }
            this.$_handleLoaderState(false);
        },
        handleLoadChanged({ name, value }) {
            this.loadValues[name] = value;
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-container {
    max-width: 600px;
}
</style>
